var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA150",
    d: "M4.3,21.5c-.5,0-.9-.2-1.3-.5s-.5-.8-.5-1.3V4.3c0-.5.2-.9.5-1.3s.8-.5,1.3-.5h15.4c.5,0,.9.2,1.3.5s.5.8.5,1.3v15.4c0,.5-.2.9-.5,1.3s-.8.5-1.3.5H4.3ZM4.3,20h15.4c0,0,.1,0,.2,0,0,0,0-.1,0-.2V4.3c0,0,0-.1,0-.2,0,0-.1,0-.2,0H4.3c0,0-.1,0-.2,0,0,0,0,.1,0,.2v15.4c0,0,0,.1,0,.2,0,0,.1,0,.2,0ZM8.8,13.9c-.2,0-.5,0-.6-.3s-.3-.4-.3-.6,0-.5.3-.6.4-.3.6-.3.5,0,.6.3c.2.2.3.4.3.6,0,.2,0,.5-.3.6-.2.2-.4.3-.6.3ZM15.2,13.9c-.2,0-.5,0-.6-.3-.2-.2-.3-.4-.3-.6s0-.5.3-.6c.2-.2.4-.3.6-.3s.5,0,.6.3c.2.2.3.4.3.6s0,.5-.3.6c-.2.2-.4.3-.6.3ZM5.5,11.2v6.2c0,.2,0,.3.2.5s.3.2.5.2h.2c.2,0,.3,0,.4-.2.1-.1.2-.3.2-.5v-1.4h10v1.4c0,.2,0,.3.2.5.1.1.3.2.5.2h.2c.2,0,.3,0,.5-.2s.2-.3.2-.5v-6.2l-1.6-4.6c0-.2-.2-.3-.3-.5-.2-.1-.3-.2-.5-.2H7.9c-.2,0-.4,0-.5.2-.2.1-.3.3-.3.5,0,0-1.6,4.6-1.6,4.6ZM7.5,10l.9-2.5h7.3l.9,2.5H7.5ZM4,4v16V4ZM7,14.5v-3h10v3H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.34ae9dc6a765a890606decc7d21744bc.svg";
export { ForwardRef as ReactComponent };